module.exports = __webpack_public_path__ + "img/78.2c96e398.jpg";